import script from "./LoyaltyMarketing.vue?vue&type=script&setup=true&lang=js"
export * from "./LoyaltyMarketing.vue?vue&type=script&setup=true&lang=js"

import "./LoyaltyMarketing.vue?vue&type=style&index=0&id=5fa09326&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fa09326"]])

export default __exports__